import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { hash } from 'rsvp';

export default class ClassGroupEditorRoute extends Route 
{
	@service store;
	
	model(params) 
	{
		var event = this.modelFor("event");
	   	return hash(
		{
			event: event,
			classGroup: this.store.findRecord('ClassGroup', params.classgroup_id)
		});
	}
}
